import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import StateLogger from "./StateLogger";
import { AIMEContextProvider } from "tot-loft-component-library";
import { Provider } from "react-redux";
import store from "./redux/store";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <StateLogger />
      <AIMEContextProvider>
        <App />
      </AIMEContextProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register();
